import { TradingHaltNotifierView } from "./trading-halt-notifier-view";
import { useTradingHaltNotifier } from "./use-trading-halt-notifier";

export const TradingHaltNotifier = ({ skipQuery = false }) => {
  const { tradingHaltEndDateTime } = useTradingHaltNotifier(skipQuery);

  return <TradingHaltNotifierView tradingHaltEndDateTime={tradingHaltEndDateTime} />;
};
